/**
 * Formato de cantidades (no montos). Las cantidades de conceptos/entradas
 * pueden venir con 0 a 6 decimales; se redondean y se muestran SIEMPRE con
 * 2 decimales para una lectura uniforme.
 *
 * @example
 *   formatearCantidad(1)        → "1.00"
 *   formatearCantidad(2.5)      → "2.50"
 *   formatearCantidad(3.14159)  → "3.14"
 */
export function formatearCantidad(cantidad: number): string {
  return cantidad.toLocaleString("es-MX", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
